import ComponentOption from 'eflex/models/component-option';
import { attr } from '@ember-data/model';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { getOwner } from '@ember/application';

@buildValidations({
  name: [validator('presence', true)],

  value: [
    validator('exclusion', {
      get in() {
        return this.model.component?.duplicateOptionValues;
      },
      get message() {
        return getOwner(this.model).lookup('service:intl').t('logs.nonUniqueFields');
      },
      get disabled() {
        return this.model.isAlwaysRun;
      },
    }),
  ],
})
class SimpleComponentOption extends ComponentOption {
  @attr('string', { defaultValue: '' }) value;
  @attr('string', { defaultValue: 'simpleComponentOption' }) type;

  get isSimple() {
    return true;
  }
}

export default SimpleComponentOption;
